<!--终端维护-->
<template>
  <div class='Terminal'>
    <section class="search-form">
      <el-form inline>
        <el-form-item label="设备ID">
          <el-input
            @keyup.native="filterInput(originData, 'logDeviceId')"
            v-model="originData.logDeviceId"
            placeholder="请输入设备ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构代码">
          <el-input
            @keyup.native="filterInput(originData, 'orgnCode')"
            placeholder="请输入机构代码"
            v-model="originData.orgnCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="交易柜员号"
          prop="交易柜员号"
        >
          <el-input
            @keyup.native="filterInput(originData, 'tellerNo')"
            placeholder="请输入交易柜员号"
            v-model="originData.tellerNo"
          ></el-input>
        </el-form-item>
      </el-form>
    </section>
    <div class="flex-between">
      <div>
        <yh-button
          type="primary"
          size="small"
          @click="handleQueryClick"
        >查询</yh-button>
        <yh-button
          size="small"
          @click="handleResetClick"
        >清空查询条件</yh-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click="visibleAdd = true"
          v-if="functionList.includes('324398940732231680')"
        >新增终端维护</yh-button>
      </div>
    </div>
    <template>
      <el-table
        :data="tableData"
        model="date"
        border
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          v-for="col in tableLabelList"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :min-width="col.width"
          :formatter="colFormatter"
        >
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          min-width="100"
        >
          <template slot-scope="scope">
            <div class="feature-container">
              <span
                class="button--blue"
                @click="handleEditClick(scope.row)"
                v-if="functionList.includes('324399020730191872')"
              >修改</span>
              <span
                class="button--red"
                v-if="functionList.includes('324399121628368896')"
                @click="handleDeleteClick(scope.row)"
              >删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />

    <yh-dialog
      title="新增终端维护"
      :visible.sync="visibleAdd"
    >
      <el-form
        :model="addData"
        inline
        class="hide-error"
      >
        <el-form-item
          label="设备ID"
          required
        >
          <el-input
            placeholder="请输入设备ID"
            v-model="addData.logDeviceId"
            @keyup.native="filterInput(addData, 'logDeviceId')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构代码"
          required
        >
          <el-input
            @keyup.native="filterInput(addData, 'orgnCode')"
            placeholder="请输入机构代码"
            v-model="addData.orgnCode"
            @blur="getOrgNameById(addData.orgnCode, 'addData')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构名称"
          required
        >
          <el-tooltip :disabled="addData.orgnName.length <= 15">
            <el-input
              disabled
              placeholder="根据机构代码填充机构名称"
              v-model="addData.orgnName"
            />
          </el-tooltip>
        </el-form-item>

        <el-form-item
          label="IP"
          required
        >
          <el-input
            placeholder="请输入外屏IP地址"
            v-model="addData.terminalIp"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="交易柜员号"
          required
        >
          <el-input
            @keyup.native="filterInput(addData, 'tellerNo')"
            placeholder="请输入交易柜员号"
            v-model="addData.tellerNo"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备MAC">
          <el-input
            placeholder="请输入设备MAC地址"
            v-model='addData.terminalMac'
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人">
          <el-input
            placeholder="请输入负责人姓名"
            v-model='addData.userName'
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            placeholder="请输入备注，不超过200字"
            autosize
            v-model='addData.termNote'
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visibleAdd = false">取 消</el-button>
        <yh-button
          type="primary"
          @click="postTM('addData')"
        >提 交</yh-button>
      </span>
    </yh-dialog>
    <yh-dialog
      title="修改终端维护"
      :visible.sync="visibleEdit"
    >
      <el-form
        inline
        class="hide-erroe"
        :model="editData"
      >
        <el-form-item
          label="设备ID"
          required
        >
          <el-input
            v-model="editData.logDeviceId"
            placeholder="请输入设备ID"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构代码"
          required
        >
          <el-input
            placeholder="请输入机构代码"
            v-model="editData.orgnCode"
            @keyup.native="filterInput(editData, 'orgnCode')"
            @blur="getOrgNameById(editData.orgnCode, 'editData')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构名称"
          required
        >
          <el-input
            placeholder="根据机构代码填充机构名称"
            v-model="editData.orgnName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="IP"
          required
        >
          <el-input
            v-model="editData.terminalIp"
            placeholder="请输入外屏IP地址"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="交易柜员号"
          required
        >
          <el-input
            placeholder="请输入交易柜员号"
            v-model="editData.tellerNo"
            @keyup.native="filterInput(editData, 'tellerNo')"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备MAC">
          <el-input
            placeholder="请输入设备MAC地址"
            v-model="editData.terminalMac"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人">
          <el-input
            placeholder="请输入负责人姓名"
            v-model="editData.userName"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            autosize
            v-model="editData.termNote"
            placeholder="请输入备注，不超过200字"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visibleEdit = false">取 消</el-button>
        <yh-button
          type="primary"
          @click="postTM('editData')"
        >提 交</yh-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import { getFunctionList, getPagingData } from '@/mixins';

const baseData = {
  logDeviceId: '',
  orgnCode: '',
  orgnName: '',
  terminalIp: '',
  tellerNo: '',
  terminalMac: '',
  userName: '',
  termNote: '',
};
export default {
  name: 'TerminalMaintenance',
  mixins: [getFunctionList, getPagingData],
  data() {
    const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      userId,
      emptyText: this.$LS.empty,
      visibleEdit: false,
      visibleAdd: false,
      tableLabelList: [{
        prop: 'logDeviceId',
        label: '设备ID',
        width: '200',
      }, {
        prop: 'orgnCode',
        label: '机构代码',
        width: '200',
      }, {
        prop: 'orgnName',
        label: '机构名称',
        width: '200',
      }, {
        prop: 'tellerNo',
        label: '交易柜员号',
        width: '200',
      }, {
        prop: 'terminalIp',
        label: 'IP',
        width: '200',
      }, {
        prop: 'terminalMac',
        label: '设备MAC',
        width: '200',
      }, {
        prop: 'userName',
        label: '负责人',
        width: '200',
      }, {
        prop: 'termNote',
        label: '备注',
        width: '300',
      }, {
        prop: 'createTime',
        label: '创建时间',
        width: '200',
      }, {
        prop: 'createUserid',
        label: '创建人ID',
        width: '200',
      }, {
        prop: 'updateTime',
        label: '修改时间',
        width: '200',
      }, {
        prop: 'updateUserid',
        label: '修改人ID',
        width: '180',
      }],
      // 初始数据
      originData: {
        logDeviceId: '',
        orgnCode: '',
        tellerNo: '',
      },
      // 查询数据
      searchParam: {
        logDeviceId: '',
        orgnCode: '',
        tellerNo: '',
      },
      sumCount: 0,
      currentPage: 1,
      pageNo: 1,
      pageSize: 10,
      addData: {
        ...baseData,
      },
      editData: {
        ...baseData,
      },
      tableData: [],
      functionList: [],
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
    visibleAdd(v) {
      if (!v) {
        Object.keys(this.addData).forEach((key) => {
          this.addData[key] = '';
        });
      }
    },
    visibleEdit(v) {
      if (!v) {
        Object.keys(this.editData).forEach((key) => {
          this.editData[key] = '';
        });
      }
    },
  },
  methods: {
    handleEditClick(data) {
      this.editData = {
        ...baseData,
        ...data,
      };
      this.visibleEdit = true;
    },
    handleDeleteClick(data) {
      this.$_yh_confirm(this.$MSG.M0159).then(() => {
        this.deleteTM(data);
      });
    },
    deleteTM(data) {
      return this.$_post(this.$API.terminalDelete, {
        data: {
          logDeviceId: data.logDeviceId,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0160);
          this.getTableData();
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    colFormatter(row, col, cellValue) {
      const needTimeFormatter = ['createTime', 'updateTime'];
      if (needTimeFormatter.includes(col.property)) {
        return this.formatTime(cellValue);
      }
      return cellValue || '-';
    },
    checkSearchData() {
      const rules = [{
        prop: 'logDeviceId',
        required: false,
        validations: [{
          message: this.$MSG.M0143,
          validate: v => v.length <= 50,
        }],
      }, {
        prop: 'orgnCode',
        required: false,
        validations: [{
          message: this.$MSG.M0144,
          validate: v => v.length <= 50,
        }],
      }, {
        prop: 'tellerNo',
        required: false,
        validations: [{
          message: this.$MSG.M0145,
          validate: v => v.length <= 50,
        }],
      }];
      return this.validate(rules, this.originData);
    },
    // 查询按钮
    handleQueryClick() {
      if (!this.checkSearchData()) {
        return;
      }
      this.searchParam = { ...this.originData };
      this.getTableData(this.pageNo, this.pageSize);
    },
    // 重置按钮
    handleResetClick() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.terminalListQuery);
    },
    // 新增和修改时的规则
    checkFormData(name) {
      function ipCheck() {
        const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        return v => reg.test(v);
      }
      const rules = [
        {
          prop: 'logDeviceId',
          message: this.$MSG.M0146,
          validations: [{
            message: this.$MSG.M0143,
            validate: v => v.length <= 50,
          }],
        },
        {
          prop: 'orgnCode',
          message: this.$MSG.M0148,
          validations: [{
            message: this.$MSG.M0144,
            validate: v => v.length <= 50,
          }],
        },
        {
          prop: 'terminalIp',
          message: this.$MSG.M0151,
          validations: [
            {
              message: this.$MSG.M0152,
              validate: ipCheck(),
            },
          ],
        },
        {
          prop: 'tellerNo',
          message: this.$MSG.M0150,
          validations: [{
            message: this.$MSG.M0145,
            validate: value => value.length <= 50,
          }],
        },
        {
          prop: 'terminalMac',
          required: false,
          validations: [{
            message: this.$MSG.M0154,
            validate: v => v.length <= 50,
          }],
        }, {
          prop: 'userName',
          required: false,
          validations: [{
            message: this.$MSG.M0155,
            validate: v => v.length <= 50,
          }],
        }, {
          prop: 'termNote',
          required: false,
          validations: [{
            message: this.$MSG.M0156,
            validate: v => v.length <= 200,
          }],
        }];
      return this.validate(rules, this[name]);
    },
    filterInput(obj, key) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = obj[key].replace(/[^0-9a-zA-Z]/g, '');
    },
    getOrgNameById(id, name) {
      if (!id) {
        this[name].orgnName = '';
        return null;
      }
      return this.$_post(this.$API.organizationGet, {
        data: {
          orgnCode: id,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this[name].orgnName = res.data.info?.orgnName || '';
        }
      });
    },
    // 新增/修改
    // 大部分逻辑相同，只有请求路径，成功信息不同
    postTM(name) {
      const map = {
        addData: {
          api: this.$API.terminalAdd,
          msg: this.$MSG.M0157,
          user: 'createUserid',
        },
        editData: {
          api: this.$API.terminalEdit,
          msg: this.$MSG.M0158,
          user: 'updateUserid',
        },
      };
      if (!this.checkFormData(name)) {
        return null;
      }
      const params = {
        data: {
          ...this[name],
          [map[name].user]: this.userId,
        },
      };
      return this.$_post(map[name].api, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.getTableData();
          this.visibleEdit = false;
          this.visibleAdd = false;
          this.$message.success(map[name].msg);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
  },
};
</script>
